<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <h3 class="text-inherit mb-4">Support information</h3>

        <p>
          Did you know the iSimulate Knowledge Base helps new and existing
          users:
          <a
            href="https://knowledge.isimulate.com/hc/en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="material-icons" style="font-size: 16px">launch</i>
            https://knowledge.isimulate.com/
          </a>
        </p>
        <div class="alert alert-secondary" role="alert">
          <strong>Are you having trouble using iSimulate software?</strong>
          From any screen in any of iSimulate's products you can perform a 'two
          fingered swipe left' gesture to report bugs and make suggestions.
        </div>

        <h4>Local Support Offices</h4>
        <p>
          Please get in touch with your local office for all other sales and
          support requests.
        </p>

        <div class="contact-row">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Australia</h5>
              <p class="card-text">
                iSimulate<br />
                G8/45 Honeysett View, Kingston ACT 2604
              </p>
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">+61 1300 474 685</li>
            </ul>
          </div>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title">America</h5>
              <p class="card-text">
                Albany Medical Centre - BACC 43 New Scotland Ave (MC #25)
                Albany, NY 12208
              </p>
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">+1-877-947-2831</li>
              <li class="list-group-item">+1-518-261-1700</li>
              <li class="list-group-item">+1-518-670-2822</li>
            </ul>
          </div>
        </div>
        <div class="contact-row">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Europe</h5>
              <p class="card-text">
                3B Scientific GmbH - Head Quarters<br />
                Ludwig-Erhard-Straße 20<br />
                20459 Hamburg<br />
                Germany
              </p>
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">+49 40 739 66 - 0</li>
            </ul>
          </div>
          <div class="card noborder"></div>
        </div>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";

export default {
  name: "MySupport",
  components: {
    UserMenu,
    CommunityCard,
    Footer,
  },
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}
.card:first-child {
  margin-right: 1rem;
}
.contact-row {
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 0 1rem;
}

.noborder {
  border: none;
}
</style>
